/**
 * コモンクラス
 * @constructor
 */
class Modal {
  constructor() {

  }
  /**
   * コモン
   */
  init() {

    /* 下記のスクリプトはslickSlider.jsに記述
       slickの読み込みの問題でSP時にボタンが効かなくなるため
       slickの動作完了以降に読み込むようにするため */
    
    // let modalNum
    // $('.j-modalBtn').on('click', (e) => {
    //   alert(4649);
    //   modalNum = $(e.currentTarget).attr('data-modal');
    //   $('.m-modal__bg').show();
    //   $('.m-modal__inner').css('display', 'flex');
    //   $(modalNum).css('display', 'flex');
    // });
    // $('.m-modal__contents--close').on('click', (e) => {
    //   $('.m-modal__bg').hide();
    //   $('.m-modal__inner').hide();
    //   $('.m-modal__contentsBlock').hide();
    //   $(modalNum).hide();
    // });
  }

}

export default Modal;
